// Orders.jsx
import './Orders.css';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useEffect, useState} from "react";
import OrderBar from "./sub/OrderBar/OrderBar.jsx";
import OrderDetails from "./sub/OrderDetails/OrderDetails.jsx";
import {fetchUserOrdersBrief} from "../../../../CustomerHandler.js";

const sortOptions = [
    { label: "Data zakupu: Od najnowszego", value: { sortKey: "PROCESSED_AT", reverse: true } },
    { label: "Data zakupu: Od najstarszego", value: { sortKey: "PROCESSED_AT", reverse: false } },
    { label: "Wartość zamówienia: Od najtańszego", value: { sortKey: "TOTAL_PRICE", reverse: false } },
    { label: "Wartość zamówienia: Od najdroższego", value: { sortKey: "TOTAL_PRICE", reverse: true } }
];




export default function Orders() {
    const [sortValue, setSortValue] = useState(sortOptions[0].value);
    const [orderToDisplay, setOrderToDisplay] = useState(null);
    const [orders, setOrders] = useState([]);

    const handleChange = (event) => {
        setSortValue(event.target.value); // value is the {sortKey, reverse} object
    };

    useEffect(() => {
        const fetchBrief = async () => {
            const token = sessionStorage.getItem("customerAccessToken");
            const fetched = await fetchUserOrdersBrief(token, sortValue);
            setOrders(fetched);
        };
        fetchBrief();
    }, [sortValue]); // refetch on sort change

    return (
        orderToDisplay === null ? (
            <div id='orders'>
                <div id='orders-top'>
                    <span id='orders-top-label-1'>Sortuj:</span>
                    <Select
                        value={sortValue}
                        onChange={handleChange}
                        size="small"
                        sx={{ minWidth: 260 }}
                        renderValue={() =>
                            (sortOptions.find(o => o.value === sortValue) || sortOptions[0]).label
                        }
                    >
                        {sortOptions.map((option) => (
                            <MenuItem key={option.label} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </div>

                <div id='orders-bottom'>
                    {orders.length > 0 && orders.map((order, index) => (
                        <OrderBar order={order} key={index} setOrderToDisplay={setOrderToDisplay} />
                    ))}
                </div>
            </div>
        ) : (
            <OrderDetails orderID={orderToDisplay} />
        )
    );
}
